import Vue from 'vue';
import VueTheMask from 'vue-the-mask';

export default () => {
  Vue.use(VueTheMask);
};

export const instagramMask = {
  mask: '@' + new Array(31).join('T'),
  tokens: {
    T: {
      pattern: /^[A-Za-z0-9_.]$/
    }
  }
};

export const twitterMask = {
  mask: '@' + new Array(16).join('T'),
  tokens: {
    T: {
      pattern: /^[A-Za-z0-9_]$/
    }
  }
};

export const masks = {
  instagramMask,
  twitterMask
};

Vue.prototype.$vMask = masks;
